import { withEllipsis } from './withEllipsis';

/**
 * A utility function to format error messages for display.
 */
export function displayError(error: unknown, maxLength = 160): string {
  // Return empty string if error is nullable.
  if (error === null || error === undefined) {
    return '';
  }

  if (typeof error === 'string') {
    return error.substring(0, maxLength);
  }

  if (error instanceof Error) {
    // Anchor the strip to the start and allow any Error subclass name. A bare `.replace('Error: ', '')`
    // matched *inside* "TypeError: ", turning "TypeError: Cannot read x" into "TypeCannot read x".
    return withEllipsis(String(error).replace(/^\w*Error: /, ''), maxLength);
  }

  if (error && typeof error === 'object' && 'message' in error && typeof error.message === 'string') {
    return withEllipsis(error.message, maxLength);
  }

  return 'An unknown error occurred';
}

/**
 * Formats a failed mutation as "Could not {verb} the {noun}. {reason}", falling back to
 * "Please try again." when the error carries no usable message. Shared across mutation flows
 * (e.g. project-nodes add/delete, report generate/delete/download) so their error snackbars
 * can't drift apart in phrasing.
 */
export function displayMutationError(verb: string, error: unknown, noun = 'instance'): string {
  const reason = displayError(error).trim();
  return `Could not ${verb} the ${noun}. ${reason || 'Please try again.'}`;
}
